import { useMemo } from 'react';

import { Event } from 'events/_types';
import isEventResolved from 'events/helpers/isEventResolved';

interface EventCounts {
  resolvedCount: number;
  openCount: number;
}

export default function useEventCounts(events: Event[]): EventCounts {
  return useMemo(
    () => ({
      resolvedCount: events.filter((e) => isEventResolved(e.status)).length,
      openCount: events.filter((e) => !isEventResolved(e.status)).length,
    }),
    [events]
  );
}
